<template>
  <div
    @click="onClick"
    :id="ques.index"
    class="question"
    :class="{ 'has-analysis': hasAnalysis, ['question-' + ques.index]: true }"
  >
    <slot name="prepand"></slot>
    <el-scrollbar
      class="parent-stem"
      :class="{ 'el-scrollbar-hide': !hasParentStemScroll }"
      v-if="ques.parent_ques_stem && (showAllParentStem || ques.is_sub_first)"
      :style="hasParentStemScroll ? 'height:330px;' : ''"
    >
      <!--        ondragstart="return false;" onselectstart="return false;" 禁止鼠标右键选中-->
      <div
        ref="parentStem"
        class="stem disSelect"
        ondragstart="return false;"
        onselectstart="return false;"
      >
        <span ref="readType" class="type">材料</span>
        <span
          ref="readStem"
          class="rich-text"
          v-html="ques.parent_ques_stem"
        ></span>
      </div>
    </el-scrollbar>
    <div
      ref="stemWrap"
      class="stem disSelect"
      :class="'stem' + ques.ques_type"
      ondragstart="return false;"
      onselectstart="return false;"
    >
      <span ref="spanType">
        <span class="num-type">
          <span>{{ ques.index }}、</span>
          <span class="type">{{ ques_type_name }}</span>
        </span>
        <span class="score" v-if="(ques.score || ques.ques_score) && showScore">
          （{{ ques.score || ques.ques_score }}分）
        </span>
      </span>
      <span ref="stem" class="rich-text" v-html="ques.ques_stem"></span>
      <div
        class="icon-result"
        :class="'icon-result-' + ques.status"
        v-if="hasAnalysis && !showAnswerBtn && ques.ques_type != 5"
      ></div>
    </div>
    <div class="options">
      <QuestionOption
        :options="ques.ques_option"
        v-model="answer[ques.question_id]"
        v-if="ques.ques_type == 1 || ques.ques_type == 2"
        @change="onChange(ques)"
        :disabled="readonly"
      ></QuestionOption>
      <QuestionOption
        :options="ques.ques_option"
        v-model="answer[ques.question_id]"
        v-else-if="ques.ques_type == 3 || ques.ques_type == 4"
        @change="onChange(ques)"
        :disabled="readonly"
        mode="checkbox"
      ></QuestionOption>
      <div
        :class="{ 'short-answer-disabled': !shotAnswerEditable }"
        v-else-if="ques.ques_type == 5 && !readonly"
      >
        <template v-if="shotAnswerEditable">
          <Editor :content.sync="answer[ques.question_id]" simple></Editor>
          <div class="upload-img-list" v-show="uploadImgs.length">
            <div
              class="img-box"
              v-for="(item, index) in uploadImgs"
              :key="index"
            >
              <img :src="item" />
              <i class="el-icon-error" @click="onDeleteImg(index)"></i>
            </div>
          </div>
          <div class="upload-img">
<!--            <el-upload-->
<!--              action-->
<!--              :before-upload="onBeforeUpload"-->
<!--              multiple-->
<!--              :disabled="uploadImgs.length >= uploadImgCountMax"-->
<!--              accept="image/jpeg, image/jpg, image/png"-->
<!--            >-->
<!--              <el-button-->
<!--                type="primary"-->
<!--                :disabled="uploadImgs.length >= uploadImgCountMax"-->
<!--              >-->
<!--                添加图片-->
<!--              </el-button>-->
<!--              <p slot="tip" class="tip">-->
<!--                最多可添加9张图片，支持png、jpg格式，最大5M-->
<!--              </p>-->
<!--            </el-upload>-->
            <template v-if="isFile == 2">
              <div class="upload-img-list" v-if="files.length">
                <div
                  class="file-box"
                  v-for="(item, index) in files"
                  :key="index"
                >
                  <div class="file-name" @click.stop="onPreview(item.path)">
                    <p
                      class="file_icon"
                      :class="{ ['file_icon-' + item.ext]: true }"
                    />
                    <span>{{ item.originalName }}</span>
                    <i
                      class="el-icon-error"
                      @click.stop="onDeleteFile(index)"
                    ></i>
                  </div>
                </div>
              </div>
              <div class="upload-img">
                <UploadOSSFile
                  multiple
                  btnLabel="添加附件"
                  @onSuccess="onSuccess"
                />
              </div>
            </template>
          </div>
        </template>
        <template v-else>
          <i class="el-icon-warning-outline"></i>
          <span class="text">
            本题不支持作答，可在交卷后核对答案并查看解析。
          </span>
        </template>
      </div>

      <div v-else-if="ques.ques_type == 7">
        <div
          class="completion-item"
          v-for="(item, index) in ques.right_answer"
          :key="index + '填空题'"
        >
          <el-input
            class="completion-input"
            v-model="answer[ques.question_id][index]"
            :placeholder="`请输入填空${index + 1}答案`"
            :disabled="readonly"
          ></el-input>
          <span class="completion-number">{{ index + 1 }}</span>

          <span
            class="completion-score"
            v-if="ques.detail && ques.detail[index].score"
          >
            ({{ ques.detail[index].score }}分)
          </span>
        </div>
      </div>
      <!-- examDoRight.vue内部监听状态进行练习模式出答案 -->
      <div
        class="practice-btn"
        v-show="
          $store.state.questionModeSelect == 2 &&
          !ques.is_confirm &&
          showAnswerBtn &&
          ques.ques_type != 1 &&
          ques.ques_type != 2
        "
        @click="
          $store.commit('setShowQuestionAnswer', { is_confirm: 1, get: true })
        "
      >
        确定
      </div>
    </div>
    <!--    错题集和收藏夹的点击出答案按钮-->
    <div
      class="btn-judge"
      v-if="
        (ques.ques_type == 3 ||
          ques.ques_type == 4 ||
          ques.ques_type == 7 ||
          ques.ques_type == 5) &&
        showJudgeBtn
      "
      @click="$emit('judge')"
    >
      确定
    </div>
    <div class="operate clearfix" v-if="showOperate">
      <a @click.stop="onShowCorrection" class="item correct" v-if="!testModel">
        纠错
      </a>
      <a
        v-if="showTagBtn"
        @click.stop="onTagClick"
        class="item tag"
        :class="{ checked: ques.is_sign == 1 }"
      >
        {{ ques.is_sign == 1 ? "已标记" : "标记" }}
      </a>
      <a
        @click.stop="collect"
        class="item favor"
        v-if="!testModel"
        :class="{ checked: ques.collect_id > 0 }"
      >
        {{ ques.collect_id > 0 ? "已收藏" : "收藏" }}
      </a>
      <a v-if="showRemoveBtn" class="item remove" @click.stop="onRemoveClick">
        移除
      </a>
    </div>

    <div
      class="analysis"
      :class="'analysis' + ques.ques_type"
      v-if="hasAnalysis"
    >
      <div
        class="answer"
        :class="'answer-' + ques.status"
        v-if="ques.ques_type != 5 && ques.ques_type != 7"
      >
        <span class="label">正确答案：</span>
        <span class="right">{{ rightAnswer }}</span>
        <span class="line">|</span>
        <span class="label">我的答案：</span>
        <span class="user">{{ userAnswer || "未作答" }}</span>
      </div>
      <div
        class="answer"
        :class="'answer-' + ques.status"
        v-else-if="ques.ques_type == 7"
      >
        <div style="display: flex; margin-bottom: 24px">
          <span class="label">我的答案：</span>
          <span v-if="!userAnswer" class="user">未作答</span>
          <div v-else>
            <div
              v-for="(item, index) in userAnswer"
              :key="index + item + 'user_answer'"
              class="completion_answer"
            >
              <!-- :class="'answer-' + " -->
              <span>{{ index + 1 }}、</span>
              <span v-if="!userAnswer[index]" class="user">未作答</span>
              <span
                v-else
                :class="{
                  user: ques.detail && ques.detail[index].is_right == 2,
                }"
              >
                {{ item }}
              </span>
            </div>
          </div>
        </div>
        <div style="display: flex">
          <span class="label">正确答案：</span>
          <div>
            <div
              v-for="(item, index) in rightAnswer"
              :key="index + item + 'right_answer'"
              class="completion_answer"
            >
              <span>{{ index + 1 }}、</span>
              <span class="right">
                {{ item }}
              </span>
            </div>
          </div>
        </div>
      </div>
      <template v-else-if="ques.ques_type == 5">
        <div
          class="analysis-detail"
          v-if="!hasReview && (ques.user_score || ques.get_score) != '-'"
        >
          <span class="label">得分：</span>
          <span>{{ ques.user_score || ques.get_score }}分</span>
        </div>
        <div class="short-answer">
          <span class="label">参考答案：</span>
          <span class="rich-text" v-html="ques.right_answer"></span>
        </div>
        <div
          class="short-answer"
          :class="'answer-' + ques.status"
          v-if="shotAnswerEditable"
        >
          <span class="label">我的答案：</span>
          <div
            v-if="
              userAnswer.content ||
              (userAnswer.images && userAnswer.images.length) ||
              (ques.attachments && ques.attachments.length)
            "
          >
            <div class="rich-text" v-html="userAnswer.content"></div>
            <div
              class="upload-img-list"
              v-show="userAnswer.images && userAnswer.images.length"
            >
              <div
                class="img-box"
                v-for="(item, index) in userAnswer.images"
                :key="index"
              >
                <img :src="item" />
              </div>
            </div>
            <div
              class="upload-img-list"
              v-show="ques.attachments && ques.attachments.length"
            >
              <div
                class="file-box"
                v-for="(item, index) in ques.attachments"
                :key="index"
              >
                <div class="file-name" @click="onPreview(item.url)">
                  <p
                    src=""
                    alt=""
                    class="file_icon"
                    :class="{ ['file_icon-' + item.ext]: true }"
                  />
                  <span>{{ item.name }}</span>
                </div>
              </div>
            </div>
          </div>
          <div v-else class="user">未作答</div>
        </div>
        <template v-if="hasReview">
          <div class="accuracy-wrap" v-if="showScore">
            <span class="label">得分：</span>
            <span class="value">{{ ques.user_score }}</span>
          </div>
          <div class="accuracy-wrap" v-else>
            <span class="label">正确率：</span>
            <span class="value">{{ ques.user_score }}%</span>
          </div>
          <div class="short-answer">
            <span class="label">点评：</span>
            <span class="rich-text" v-html="ques.review_comment || '--'"></span>
          </div>
          <div
            class="accuracy-wrap upload-img-list appove-file"
            v-show="ques.review_attachments && ques.review_attachments.length"
          >
            <span class="label">附件：</span>
            <div
              class="file-box"
              v-for="(item, index) in ques.review_attachments"
              :key="index"
            >
              <div class="file-name" @click="onPreview(item.url)">
                <p
                  src=""
                  alt=""
                  class="file_icon"
                  :class="{ ['file_icon-' + item.ext]: true }"
                />
                <span>{{ item.name }}</span>
              </div>
            </div>
          </div>
        </template>
      </template>
      <div class="analysis-detail">
        <span class="label">解析：</span>
        <span
          class="rich-text"
          v-html="ques.ques_analysis"
          v-if="ques.ques_analysis"
        ></span>
        <span v-else>暂无解析</span>
      </div>
      <div class="point-wrap" v-if="showPoint && !testModel">
        <span class="label">知识点：</span>
        <span class="point" v-for="(p, index) in ques.points" :key="index">
          {{ p.name || p }}
        </span>
      </div>
      <div class="degree-wrap" v-if="ques.facility_value">
        <span class="label">难易度：</span>
        <span
          class="degree degree-checked"
          v-for="i in 6 - ques.facility_value"
          :key="'checked' + i"
        ></span>
        <span
          class="degree"
          v-for="i in ques.facility_value - 1"
          :key="i"
        ></span>
      </div>
      <div
        class="accuracy-wrap"
        v-if="ques.ques_type != 5 && showAccuracy && !testModel"
      >
        <span class="label">全站正确率：</span>
        <span class="value">{{ ques.accuracy }}</span>
      </div>
      <div class="accuracy-wrap" v-if="hasReview">
        <span class="label">平均正确率：</span>
        <span class="value">{{ ques.aver_rate }}</span>
      </div>
      <div class="operate clearfix" v-if="showAnalysisBtn && !testModel">
        <a @click.stop="onShowCorrection" class="item correct">纠错</a>
        <a
          @click.stop="collect"
          class="item favor"
          :class="{ checked: ques.collect_id > 0 }"
        >
          {{ ques.collect_id > 0 ? "已收藏" : "收藏" }}
        </a>
      </div>
    </div>
    <el-dialog
      title="题目纠错"
      class="dialog-correction"
      :visible.sync="showCorrection"
      width="560px"
    >
      <div class="form-item">
        <label>错误类型：</label>
        <el-checkbox-group v-model="correction.types">
          <el-checkbox :label="1">题干错误</el-checkbox>
          <el-checkbox :label="2" v-if="ques.ques_type != 5">
            选项错误
          </el-checkbox>
          <el-checkbox :label="3" v-if="from == 'analysis'">
            答案错误
          </el-checkbox>
          <el-checkbox :label="4" v-if="from == 'analysis'">
            解析错误
          </el-checkbox>
        </el-checkbox-group>
      </div>
      <div class="form-item">
        <label>错误描述：</label>
        <el-input
          type="textarea"
          :rows="9"
          v-model="correction.error_description"
          :maxlength="200"
          show-word-limit
        ></el-input>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="default" @click="showCorrection = false">
          取消
        </el-button>
        <el-button type="primary" @click="submitCorrection">提交</el-button>
      </span>
    </el-dialog>
    <ImageViewer :isShow.sync="showImageViewer" :images="images"></ImageViewer>
  </div>
</template>
<script>
import ImageViewer from "@/components/ImageViewer.vue";
import Editor from "@/components/Editor.vue";
import { ExamTopicType } from "@/utils/enums";
import QuestionOption from "./QuestionOption";
import UploadOSSFile from "@/components/UploadOSSFile";
export default {
  name: "Question",
  components: { ImageViewer, Editor, QuestionOption, UploadOSSFile },
  props: {
    testModel: {
      type: Boolean,
      default: false,
    },
    ques: {
      type: Object,
    },
    answer: {
      type: Object,
    },
    answerImg: {
      type: Object,
    },
    files: {
      type: Array,
      default: () => [],
    },
    readonly: {
      type: Boolean,
      default: false,
    },
    hasAnalysis: {
      type: Boolean,
      default: false,
    },
    showOperate: {
      type: Boolean,
      default: false,
    },
    showScore: {
      type: Boolean,
      default: true,
    },
    shotAnswerEditable: {
      type: Boolean,
      default: false,
    },
    showRemoveBtn: {
      type: Boolean,
      default: false,
    },
    showTagBtn: {
      type: Boolean,
      default: true,
    },
    reportId: {},
    from: {
      type: String,
      default: "",
    },
    showJudgeBtn: {
      type: Boolean,
      default: false,
    },
    showAnalysisBtn: {
      type: Boolean,
      default: true,
    },
    isFile: {
      type: Number,
      default: 100,
    },
    showAllParentStem: {
      type: Boolean,
      default: true,
    },
    showPoint: {
      type: Boolean,
      default: true,
    },
    showAccuracy: {
      type: Boolean,
      default: true,
    },
    hasReview: {
      type: Boolean,
      default: false,
    },
    autoMathJax: {
      type: Boolean,
      default: true,
    },
    showAnswerBtn: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      showCorrection: false,
      correction: {
        types: [],
        error_description: "",
      },
      images: [],
      showImageViewer: false,
      uploadImgCountMax: 9,
      hasParentStemScroll: false,
    };
  },
  watch: {
    answer: {
      deep: true,
      handler: function () {
        if (this.ques.ques_type == 5 || this.ques.ques_type == 7) {
          this.onChange(this.ques);
        }
      },
    },
    answerImg: {
      deep: true,
      handler: function () {
        this.onChange(this.ques);
      },
    },
    files: {
      deep: true,
      handler: function () {
        this.onChange(this.ques);
      },
    },
    ques() {
      this.$nextTick(async () => {
        if (this.autoMathJax) {
          await window.MathJax.typesetPromise([".question-" + this.ques.index]);
        }
        this.formatStem();
        this.formatReadStem();
        this.initParentStem();
      });
    },
  },
  computed: {
    ques_type_name() {
      let str = this.ques.ques_type
        ? ExamTopicType.getValue(this.ques.ques_type).replace("题", "")
        : "";
      return str;
    },
    uploadImgs() {
      if (!this.answerImg) {
        return [];
      }
      return this.answerImg[this.ques.ques_id || this.ques.question_id] || [];
    },
    rightAnswer() {
      let ques = this.ques;
      if (ques.ques_type == 1 || ques.ques_type == 2) {
        let id = ques.ques_option.filter(o => o.is_right == 1)[0].id;
        return String.fromCharCode(64 + parseInt(id));
      } else if (ques.ques_type == 3 || ques.ques_type == 4) {
        let ids = [];
        let answers = [];
        ques.ques_option
          .filter(o => o.is_right == 1)
          .forEach(o => {
            ids.push(o.id);
            answers.push(String.fromCharCode(64 + o.id));
          });
        return answers.join("");
      } else if (ques.ques_type == 7) {
        return ques.right_answer.map(item =>
          Array.isArray(item) ? item.join("、") : item,
        );
      }
      return ques;
    },
    userAnswer() {
      let ques = this.ques;

      if (
        Array.isArray(ques.user_answer)
          ? ques.user_answer.some(Boolean)
          : ques.user_answer
      ) {
        if (ques.ques_type != 5 && ques.ques_type != 7) {
          let answers = [];
          let array = ques.user_answer.split(",");
          array.forEach(a => {
            if (!a) {
              return;
            }
            answers.push(String.fromCharCode(64 + parseInt(a)));
          });
          return answers.join("");
        } else if (ques.ques_type != 7) {
          return JSON.parse(ques.user_answer);
        } else if (ques.ques_type == 7) {
          return Array.isArray(ques.user_answer)
            ? ques.user_answer
            : ques.user_answer.split("@@");
        }
      }
      return "";
    },
  },
  methods: {
    onSuccess(file) {
      this.$emit("addFile", file);
    },
    onPreview(url) {
      window.open(url);
    },
    initParentStem() {
      this.$nextTick(() => {
        if (!this.$refs.parentStem) {
          return;
        }
        if (this.$refs.parentStem.clientHeight > 330) {
          this.hasParentStemScroll = true;
        } else {
          this.hasParentStemScroll = false;
        }
      });
    },
    onChange(ques) {
      this.$emit("change", ques);
    },
    onDeleteImg(index) {
      this.$emit("deleteImg", this.ques, index);
    },
    onDeleteFile(index) {
      this.$emit("deleteFile", index);
    },
    onBeforeUpload(file) {
      const formData = new FormData();
      formData.append("file", file);
      formData.append("width", "1000");
      this.$http.post("/api/app/public/img", formData).then(data => {
        if (this.uploadImgs.length < this.uploadImgCountMax) {
          this.$emit("addImg", this.ques, data.path);
        }
      });
      return false;
    },
    onShowCorrection() {
      this.showCorrection = true;
      this.correction.types = [];
      this.correction.error_description = "";
    },
    async submitCorrection() {
      if (this.correction.types.length === 0) {
        this.$info("请选择错误类型");
        return;
      }
      if (this.correction.error_description === "") {
        this.$info("请输入错误描述");
        return;
      }
      await this.$http.post("/api/app/question/error/record", {
        ques_id: this.ques.question_id,
        error_type: this.correction.types.join(","),
        error_description: this.correction.error_description,
      });
      this.showCorrection = false;
      this.$success("提交成功");
    },
    async collect() {
      if (this.ques.collect_id > 0) {
        await this.$http.put(
          "/api/app/collect/cancel/" + this.ques.collect_id + "/3",
        );
        this.ques.collect_id = null;
        this.$success("取消收藏成功");
      } else {
        this.ques.collect_id = await this.$http.post("/api/app/collect", {
          ques_id: this.ques.question_id,
          type: 3,
        });
        this.$success("收藏成功");
      }
    },
    onClick(event) {
      let target = event.target;
      if (target.tagName.toLowerCase() == "img") {
        this.images = [target.src];
        this.showImageViewer = true;
      }
    },
    async onTagClick() {
      let isSign = this.ques.is_sign == 1 ? 2 : 1;
      await this.$http.post("/api/app/practice/sign", {
        report_id: this.reportId,
        question_id: this.ques.question_id,
        is_sign: isSign,
      });
      this.ques.is_sign = isSign;
    },
    async onRemoveClick() {
      await this.$promiseConfirm("确定将此题从错题集中移除？");
      await this.$http.post("/api/app/myExam/quesRemove", {
        ques_id: this.ques.question_id,
      });
      this.$success("移除成功");
    },
    formatStem() {
      //题干上传附件，查看时打开新窗口查看
      if (this.ques.ques_stem) {
        this.ques.ques_stem = this.ques.ques_stem.replace(
          /<a/g,
          '<a target="_blank"',
        );
      }
      let p = this.$refs.stem.childNodes[0];
      if (p && p.tagName == "P") {
        if (p.childNodes[0].className != "stem-wrap") {
          let span = document.createElement("span");
          span.className = "stem-wrap";
          span.style.marginRight = "5px";
          span.innerHTML = this.$refs.spanType.innerHTML;
          p.insertBefore(span, p.childNodes[0]);
          this.$refs.stem.style.display = "inline-block";
          this.$refs.stem.style.margin = "0";
          this.$refs.spanType.style.display = "none";
        }
      } else {
        this.$refs.stem.style.display = "inline";
        this.$refs.stem.style.marginLeft = "5px";
        this.$refs.spanType.style.display = "inline-block";
      }
    },
    formatReadStem() {
      if (!this.$refs.readStem) {
        return;
      }
      let p = this.$refs.readStem.childNodes[0];
      if (p && p.tagName == "P") {
        let span = this.$refs.readType.cloneNode(true);
        span.style.marginRight = "5px";
        p.insertBefore(span, p.childNodes[0]);
        this.$refs.readStem.style.display = "inline-block";
        this.$refs.readStem.style.margin = "0";
        this.$refs.readType.style.display = "none";
      } else {
        this.$refs.readStem.style.display = "inline";
        this.$refs.readStem.style.marginLeft = "5px";
        this.$refs.readType.style.display = "inline-block";
      }
    },
  },
  mounted() {
    this.$nextTick(async () => {
      if (this.autoMathJax) {
        await window.MathJax.typesetPromise([".question-" + this.ques.index]);
      }
      this.formatStem();
      this.formatReadStem();
      this.initParentStem();
    });
  },
};
</script>
<style lang="scss" scoped>
.question {
  padding: 20px 20px 0 20px;
  position: relative;
  //控制不能选中
  .disSelect {
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
  }
  &:last-child {
    border-bottom: none;
  }
  &.has-analysis {
    .options,
    .stem {
      padding-left: 0;
    }
  }
  .btn-judge {
    width: 96px;
    height: 36px;
    background: rgba(252, 86, 35, 1);
    border-radius: 4px;
    margin: 0 0 35px 10px;
    cursor: pointer;
    text-align: center;
    line-height: 36px;
    color: white;
    font-size: 14px;
  }

  .practice-btn {
    cursor: pointer;
    margin-top: 32px;
    padding: 7px 32px;
    background: rgba(252, 86, 35, 1);
    border-radius: 4px;
    display: inline-block;
    color: #fff;
  }

  .score {
    color: #666666;
  }
  .options {
    margin-bottom: 36px;
    padding: 0 10px;
  }
  .icon-result {
    position: absolute;
    left: -56px;
    top: 10px;
    width: 38px;
    height: 26px;
    background-size: 100% 100%;
  }
  .icon-result-1 {
    background-image: url("~@/assets/images/exam/analysis-right@2x.png");
  }
  .icon-result-2 {
    background-image: url("~@/assets/images/exam/analysis-wrong@2x.png");
  }
  .icon-result-3 {
    background-image: url("~@/assets/images/exam/analysis-none@2x.png");
  }
  .icon-result-4 {
    background-image: url("~@/assets/images/exam/analysis-waiting@2x.png");
  }
  .stem {
    font-size: 16px;
    color: #333333;
    margin-bottom: 35px;
    padding: 10px 10px 0 10px;
    position: relative;
    &.stem5 {
      margin-bottom: 20px;
    }
    .num-type {
      white-space: nowrap;
    }
    .type {
      background: rgba(252, 144, 38, 1);
      border-radius: 3px;
      font-size: 13px;
      color: white;
      padding: 2px 8px;
    }
    .rich-text {
      margin-left: 5px;
      display: inline-block;
      line-height: 28px;
    }
    .rich-text /deep/ p{
      display:flex;
      flex-wrap:wrap;
      align-items:center
    }
    .rich-text /deep/ div{
      display:flex;
      flex-wrap:wrap;
      align-items:center
    }
  }
  .parent-stem {
    margin-bottom: 29px;
    padding: 0;

    .stem {
      margin-bottom: 0;
    }

    /deep/ {
      .el-scrollbar__wrap {
        overflow-x: hidden;
      }
    }

    &.el-scrollbar-hide {
      /deep/ {
        .el-scrollbar__wrap {
          margin-bottom: 0 !important;
          margin-right: 0 !important;
          overflow: hidden;
        }
      }
    }
  }
  .rich-text.stem5 {
    margin-bottom: 40px;
  }
  /deep/.word-p{

    display: flex !important;
    align-items: center !important; /* 这一行将内容底部对齐 */
  }
  
  .analysis {
    overflow: hidden;
    position: relative;
    .operate {
      position: absolute;
      right: 27px;
      bottom: 29px;
      padding-bottom: 0;
      .item {
        width: auto;
      }
      .favor {
        margin-right: 22px;
      }
    }
    .answer {
      font-size: 14px;
      color: rgba(153, 153, 153, 1);
      line-height: 1;
      margin-bottom: 25px;
      .right {
        color: #13cc59;
      }
      .line {
        margin: 0 16px;
      }

      .completion_answer:not(:last-child) {
        margin-bottom: 10px;
      }
    }
    .answer-1 {
      .user {
        color: #13cc59;
      }
    }
    .answer-2,
    .answer-3 {
      .user {
        color: #ff2d28;
      }
    }
    .short-answer {
      margin-bottom: 25px;
      font-size: 14px;
      display: flex;
      .label {
        color: rgba(153, 153, 153, 1);
        margin-right: 3px;
        flex-shrink: 0;
      }
      .rich-text {
        color: rgba(51, 51, 51, 1);
      }
    }
    &.analysis5 {
      padding-top: 0;
      .detail {
        padding-left: 0;
      }
    }
    .analysis-detail {
      font-size: 14px;
      margin-bottom: 26px;
      display: flex;
      .label {
        color: rgba(153, 153, 153, 1);
        margin-right: 27px;
        flex-shrink: 0;
      }
      .rich-text {
        color: rgba(51, 51, 51, 1);
      }
    }
    .point-wrap {
      display: flex;
      flex-wrap: wrap;
      .label {
        font-size: 14px;
        font-family: PingFang SC;
        color: rgba(153, 153, 153, 1);
        line-height: 1;
        margin: 8px 14px 0 0;
      }
      .point {
        height: 28px;
        padding: 0 13px;
        background: rgba($primary-color, 0.1);
        border-radius: 3px;
        margin-right: 10px;
        color: $primary-color;
        text-align: center;
        line-height: 28px;
        margin-bottom: 17px;
        &:last-child {
          margin-right: 0;
        }
      }
    }
    .degree-wrap {
      display: flex;
      align-items: center;
      margin-bottom: 20px;
      .label {
        font-size: 14px;
        font-family: PingFang SC;
        color: rgba(153, 153, 153, 1);
        line-height: 1;
        margin-right: 14px;
      }
      .degree {
        width: 14px;
        height: 19px;
        background-size: 100% 100%;
        margin-right: 6px;
        background-image: url("~@/assets/images/exam/degree@2x.png");
      }
      .degree-checked {
        background-image: url("~@/assets/images/exam/degree-checked@2x.png");
      }
    }
    .accuracy-wrap {
      margin-bottom: 30px;
      .label {
        font-size: 14px;
        font-family: PingFang SC;
        color: rgba(153, 153, 153, 1);
        line-height: 1;
        margin-right: 17px;
      }
      .value {
        font-size: 16px;
        font-family: PingFang SC;
        color: rgba(19, 204, 89, 1);
        line-height: 1;
      }
    }
    .appove-file {
      display: flex;
      align-items: center;
    }
  }
  .operate {
    padding-bottom: 36px;

    .item {
      font-size: 14px;
      height: 20px;
      background-repeat: no-repeat;
      background-size: 20px 20px;
      padding-left: 25px;
      line-height: 20px;
      cursor: pointer;
      float: right;
      box-sizing: border-box;
      width: 86px;

      &:hover,
      &.checked {
        color: #f18b07;
      }
    }

    .favor {
      background-image: url("~@/assets/images/exam/favor@2x.png");
      margin-right: 12px;

      &:hover,
      &.checked {
        background-image: url("~@/assets/images/exam/favor-checked@2x.png");
      }
    }

    .tag {
      background-image: url("~@/assets/images/exam/tag@2x.png");
      margin-right: 15px;

      &:hover,
      &.checked {
        background-image: url("~@/assets/images/exam/tag-checked@2x.png");
      }
    }

    .correct {
      background-image: url("~@/assets/images/exam/correct@2x.png");
      width: auto;

      &:hover,
      &.checked {
        background-image: url("~@/assets/images/exam/correct-checked@2x.png");
      }
    }

    .remove {
      background-image: url("~@/assets/images/exam/remove@2x.png");

      &:hover,
      &.checked {
        background-image: url("~@/assets/images/exam/remove-checked@2x.png");
      }
    }
  }
}
.dialog-correction {
  /deep/ {
    .el-dialog {
      padding: 22px 22px 20px 22px;
    }
    .el-dialog__header {
      padding: 0;
      margin-bottom: 26px;
    }
    .el-dialog__title {
      font-size: 16px;
      font-family: PingFang SC;
      font-weight: 500;
      color: rgba(51, 51, 51, 1);
      line-height: 1;
    }
    .el-dialog__headerbtn {
      display: none;
    }
    .el-dialog__body {
      padding: 0;
    }
    .el-dialog__footer {
      padding: 20px 0 0 0;
    }
    .el-button {
      width: 88px;
      height: 36px;
      border-radius: 3px;
      padding: 0;
      + .el-button {
        margin-left: 14px;
      }
    }
    .el-button--default {
      background-color: white;
    }
  }
  .form-item {
    label {
      font-size: 14px;
      color: rgba(102, 102, 102, 1);
      line-height: 1;
    }
    > label {
      &::before {
        content: "*";
        color: #ff2d28;
      }
    }
    &:first-child {
      align-items: center;
    }
    &:nth-child(2) {
      flex-direction: column;
      label {
        margin-bottom: 12px;
      }
    }
    /deep/ {
      .el-checkbox__label {
        color: #333333;
        line-height: 1;
        font-weight: 400;
      }
    }
  }
}
.short-answer-disabled {
  width: 418px;
  height: 36px;
  background: rgba(245, 245, 245, 1);
  display: flex;
  align-items: center;
  padding-left: 8px;
  border-radius: 3px;

  .el-icon-warning-outline {
    color: #f18c08;
    margin-right: 10px;
  }

  .text {
    font-size: 13px;
    color: rgba(154, 154, 154, 1);
  }
}

.completion-item {
  position: relative;
  display: flex;
  align-items: center;

  &:not(:last-child) {
    margin-bottom: 24px;
  }

  .completion-input {
    width: 480px;

    /deep/ input {
      border: none;
      height: 46px;
      padding-left: 46px;
      background: #f7f7f7;
      border-radius: 8px;
    }
  }

  .completion-number {
    width: 46px;
    text-align: center;
    position: absolute;
    left: 0;
    top: 0;
    height: 100%;
    line-height: 46px;
  }

  .completion-score {
    margin-left: 16px;
  }
}
</style>
<style lang="scss">
.analysis-detail img {
  max-width: 100%;
}
.upload-img {
  margin-top: 20px;
  .tip {
    margin-top: 13px;
    font-size: 13px;
    color: #b2b2b2;
  }
}


</style>
